<ng-container>
    @if (predefineFilters.sorting) {
        <st-list-drop-down
            class="left"
            mobileIcon="sort"
            [label]="languageSettings?.PSTWebSortByLabel"
            [value]="sortByField()"
            [list]="predefineFilters.sorting"
            (valueOutput)="setSortByField($event)" />
    }
</ng-container>
